import { render, staticRenderFns } from "./workerIdCard.vue?vue&type=template&id=562bcd17&"
import script from "./workerIdCard.vue?vue&type=script&lang=js&"
export * from "./workerIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports